// extracted by mini-css-extract-plugin
export var cartContainer = "_ov-4";
export var gray = "_ov-1";
export var itemContainer = "_ov-2";
export var itemDetails = "_ov-3";
export var strong = "_ov-0";